import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId,
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.authService.logout();
      this.router.navigate(['/auth/login']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/accounts/logout/logout.component.ts